import { Node } from '../Node';

export const Divider = Node.create({
  name: 'divider',
  nodeType: 'br',
  group: 'block',
});
